import axios from 'axios';
import store from '../app.store';
import config from './config.service';
import { SET_LOADING, SET_ERROR } from '../store/global.mutations.types';
import JwtService from './jwt.service';
const AUTH_HEADER = 'x-auth-token';

class ApiService {
  constructor() {
    axios.defaults.baseURL = config.API_URL;
    this.setRequestHandlers();
    this.setResponseHandlers();
  }

  setRequestHandlers() {
    axios.interceptors.request.use(
      (config) => this.requestHandler(config),
      (error) => this.requestErrorHandler(error)
    );
  }

  setResponseHandlers() {
    axios.interceptors.response.use(
      async (response) => await this.responseHandler(response),
      async (error) => await this.responseErrorHandler(error)
    );
  }

  requestHandler(config) {
    store.commit(SET_LOADING, true);
    if (JwtService.getApiKey()) {
      config.headers.common = {
        ...config.headers.common,
        [AUTH_HEADER]: JwtService.getApiKey(),
      };
    }
    return config;
  }

  requestErrorHandler(error) {
    store.commit(SET_LOADING, false);
    return Promise.reject(error);
  }

  async responseHandler(response) {
    store.commit(SET_LOADING, false);
    return response.data;
  }

  async responseErrorHandler(error) {
    store.commit(SET_LOADING, false);
    const { response } = error;
    const statusText = response?.statusText ?? 'Unknown Error';
    const data = response?.data ?? { message: statusText };

    const sessionToken = JwtService.getSessionToken();
    if (
      response.status === 401 ||
      (error.code === 'ERR_NETWORK' && JwtService.isExpired(sessionToken))
    ) {
      const apiKey = JwtService.getApiKey();
      if (sessionToken && apiKey) {
        JwtService.destroyApiKey();
        const auth = await store.dispatch('setApiKey');
        if (auth && auth.token) {
          error.config.headers['x-auth-token'] = auth.token;
          return axios(error.config);
        }
      }
      store.dispatch('logout');
    }

    if (response.status === 403 && !data.errorCode) {
      store.dispatch('logout');
    }

    store.dispatch(SET_ERROR, error);
    return Promise.reject(data);
  }

  get(resource, config) {
    return axios.get(resource, config);
  }

  post(resource, data, config) {
    return axios.post(resource, data, config);
  }

  put(resource, data, config) {
    return axios.put(resource, data, config);
  }

  delete(resource) {
    return axios.delete(resource);
  }
}

const instance = new ApiService();

export default instance;
